import { combineReducers } from 'redux';

import activeEditor from './activeTiptapEditorReducer';

export default combineReducers({
    activeEditor,
});
